export default __webpack_public_path__ + "static/media/Jude 9781408357729.825d3524.jpg";